export const DEFAULT_LANGUAGE = 'en-US';
export const TEACHER = 'TEACHER';
export const STUDENT = 'STUDENT';
export const SCHOOL_ADMIN = 'SCHOOL_ADMIN';
export const DISTRICT_OWNER = 'DISTRICT_OWNER';
